import * as constants from './actions';

import { getInitiatedTime, getTimeFrom } from '../../utils/actionTiming';

const initialState = {
    actionInitiated: false,
    actionCancelled: false,
    isFormSubmitting: false,
    checkRegistrationError: null,
    answerHistory: []
};

export default function checkRegistration(state = initialState, { type, payload }) {
    switch (type) {
        case constants.CHECK_REGISTRATION_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                actionInitiated: true
            };
        case constants.CHECK_REGISTRATION_SUBMITTING:
            return {
                ...state,
                isFormSubmitting: payload.isFormSubmitting
            };
        case constants.CHECK_REGISTRATION_COMPLETED:
            return {
                ...state,
                answerHistory: (state.answerHistory || []).concat([
                    {
                        actionIdentifier: payload.actionIdentifier,
                        answerId: payload.answerId
                    }
                ]),
                actionCompletionTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload.actionIdentifier, state))[0]
                ),
                completeCheckRegistration: payload
            };
        case constants.CHECK_REGISTRATION_CANCELLED:
            return {
                ...state,
                actionCancelled: true,
                actionCancelledTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.CHECK_REGISTRATION_ERROR:
            return {
                ...state,
                checkRegistrationError: payload
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier]
            };
        default:
            return state;
    }
}
